import { Metamodel } from 'app/model/base/model';
import { IModel, IAttribute, IViolation } from 'app/model/base/annotation';

import { format } from 'app/shared/utils/string.util';
import { AdobeExperiencePlatformObjectDataset } from 'app/model/dataset/adobe-experience-platform.dataset';
import { CopySource } from './copysource';

@Metamodel.model({
    name: 'AdobeExperiencePlatformSource',
    display: [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.AdobeExperiencePlatform_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.AdobeExperiencePlatform_DisplayText)
    ],
    tags: { datasetModel: Metamodel.modelFor(AdobeExperiencePlatformObjectDataset) }
})
export class AdobeExperiencePlatformCopySource extends CopySource {
    public static readonly MODEL: IModel;
    public static readonly COMPLETED_DATETIME_START: IAttribute;
    public static readonly COMPLETED_DATETIME_END: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPLETED_DATETIME_START',
        constraint: {
            required: true
        },
        display: stringResources.ModelName_CompletedDateTimeStart
    })
    public completedDateTimeStart?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPLETED_DATETIME_END',
        constraint: {
            validator: AdobeExperiencePlatformCopySource.validateCompletedDateTimeEnd
        },
        display: stringResources.ModelName_CompletedDateTimeEnd
    })
    public completedDateTimeEnd?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCompletedDateTimeEnd(aepSource: AdobeExperiencePlatformCopySource): IViolation[] | undefined {
        const result: IViolation[] = [];
        try {
            if (aepSource && aepSource.completedDateTimeEnd == null &&
                !AdobeExperiencePlatformCopySource.COMPLETED_DATETIME_END.templateValue(aepSource)) {
                result.push({
                    context: aepSource.completedDateTimeEnd,
                    message: () => format(stringResources.RequiredValidatorMessageNoVowel, stringResources.ModelName_CompletedDateTimeEnd,
                        format(stringResources.ModelName_CopySourceTemplate, stringResources.AdobeExperiencePlatform_DisplayText), '')
                });
            }
            if (aepSource && aepSource.completedDateTimeStart != null && aepSource.completedDateTimeEnd != null &&
                !AdobeExperiencePlatformCopySource.COMPLETED_DATETIME_START.templateValue(aepSource) &&
                !AdobeExperiencePlatformCopySource.COMPLETED_DATETIME_END.templateValue(aepSource)) {
                if (Date.parse(aepSource.completedDateTimeStart) >= Date.parse(aepSource.completedDateTimeEnd)) {
                    result.push(
                        {
                            context: aepSource.completedDateTimeEnd,
                            message: () => stringResources.AdobeExperiencePlatfor_CompletedDateTimeError
                        }
                    );
                }
            }
        } catch {
            // do nothing
        }
        return result;
    }
}
